export const socket = (win) => ({ 'X-Socket-Id': win.Echo.socketId() });
export const captcha = (token, version) => ({ 'x-captcha-token': token, 'x-captcha-version': version });
export const csrf = (doc) => {
    var _a, _b;
    return ({ 'X-CSRF-TOKEN': (_b = (_a = doc.head.querySelector('[name="csrf-token"]')) === null || _a === void 0 ? void 0 : _a.getAttribute('content')) !== null && _b !== void 0 ? _b : '' });
};
